import React, { useState } from "react";
import { Error } from "@progress/kendo-react-labels";
import Loader from "../../control-components/loader/loader";
import ErrorHelper from "../../helper/error-helper";
import { NotificationManager } from "src/util/notify";
import { Upload } from "@progress/kendo-react-upload";
import APP_ROUTES from "../../helper/app-routes";
import { useNavigate } from "react-router";
import { AdminService } from "../../services/adminService";

const EobImport = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validateError, setValidateError] = useState(false);
  const [files, setFiles] = React.useState([]);
  const [uploadError, setUploadError] = useState(false);
  const [extensionError, setExtensionError] = useState(false);
  const [errors, setErrors] = useState("");

  const handleSubmit = () => {
    setValidateError(true);
    if (handleValidation()) {
      saveEobFiles();
    }
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (files.length === 0) {
      formIsValid = false;
      errors["upload"] = ErrorHelper.UPLOAD_DOCUMENT;
      setUploadError(true);
    }
    setErrors(errors);
    return formIsValid;
  };

  const onAdd = (event) => {
    setExtensionError(false);
    setFiles(event.newState);
    setUploadError(false);
  };
  const onRemove = (event) => {
    setFiles(event.newState);
  };

  const saveEobFiles = async () => {
    const filteredFiles = files.filter((file) => {
      const extension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      return [".dat", ".edi", ".txt"].includes(extension);
    });
    if (filteredFiles.length === 0) {
      setFiles([]);
      setExtensionError(true);
      return;
    }
    setLoading(true);
    let data = {
      files:
        filteredFiles.length > 0
          ? filteredFiles.map((file) => file.getRawFile())
          : null,
    };
    await AdminService.saveEobFiles(data)
      .then((result) => {
        setLoading(false);
        setFiles([]);
        NotificationManager.success("Upload file successfully");
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
  };
  const onCancel = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };

  return (
    <>
      <div className="d-flex flex-wrap">
        {loading === true && <Loader />}
        <div className="col-md-9 col-lg-10">
          <div className="Service-RateList">
            <div className="d-flex justify-content-between  mt-3">
              <h4 className="address-title text-grey ">
                <span className="f-24">EOB Import</span>
              </h4>
            </div>
          </div>
          <div className="col mt-3 ">
            <div className="mb-3 col-lg-5 col-md-6 col-12 px-0  custom-drop">
              <Upload
                batch={false}
                multiple={true}
                autoUpload={false}
                onAdd={onAdd}
                onRemove={onRemove}
                files={files}
                showActionButtons={false}
                restrictions={{
                  allowedExtensions: [".dat", ".edi", ".txt"],
                }}
              />
              {(uploadError && <Error>Document is required</Error>) ||
                (extensionError && <Error>Enter Valid Document</Error>)}
            </div>

            <div className="footer-composer mt-2 col-lg-5 col-md-6 col-12 px-0">
              <span className="position-relative">
                <div className="d-flex mt-4">
                  <div className="right-sde">
                    <button
                      className="green-btn btn-primary"
                      onClick={handleSubmit}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="right-sde-grey mx-3">
                    <button
                      className="btn grey-secondary text-white "
                      onClick={onCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EobImport;
